import { render, staticRenderFns } from "./TowerDetector.vue?vue&type=template&id=5ea27c4f"
import script from "./TowerDetector.vue?vue&type=script&lang=js"
export * from "./TowerDetector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports